import type CredReqEventAttachmentType from '$shared/constants/CredReqEventAttachmentType';
import { getFileNameFromPath, isValidPath } from '$shared/helpers/utils';
import type { ICredReqEventAttachment } from '$shared/interfaces/api/ICredReqEventAttachment';

export default class CredReqEventAttachment {
  public id: string;
  public type: CredReqEventAttachmentType;
  public path: string;

  constructor(response: ICredReqEventAttachment) {
    if (!response) {
      return;
    }
    this.id = response.id || '';
    this.type = response.type;
    this.path = response.path;
  }

  public get isValidPath(): boolean {
    return isValidPath(this.path);
  }

  public get fileName(): string {
    if (!this.path) {
      return '';
    }

    if (!this.isValidPath) {
      return '';
    }
    return getFileNameFromPath(this.path);
  }
}
